import React, { ReactNode } from 'react';

import '@cosmos/modal/modal-header';

type ModalHeaderProps = {
  children?: ReactNode;
  className?: string;
};

const ModalHeader = ({ children, className = '' }: ModalHeaderProps) => {
  return <hot-modal-header class={className}>{children}</hot-modal-header>;
};

export default ModalHeader;
